export default class Part {
    static render(width, mods) {
        // const WIDTH = width * SIZE.pxInMm;/
        const HEIGHT = SIZE.baseHeight // TODO  
        let x = width * SIZE.pxInMm - 55
        let y = 117.7;
        return `<image href="${PARTS.point}" x="${x}" y="${y}" />`
    }
}
